'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _clickableImage = require('./clickable-image');

var _clickableImage2 = _interopRequireDefault(_clickableImage);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Tab = _react2['default'].createClass({
    displayName: 'Tab',

    propTypes: {
        index: _react2['default'].PropTypes.number.isRequired,
        onTabClick: _react2['default'].PropTypes.func.isRequired,
        clickableItemData: _react2['default'].PropTypes.object,
        isActive: _react2['default'].PropTypes.bool.isRequired,
        tabClassNames: _react2['default'].PropTypes.object,
        tabTypes: _react2['default'].PropTypes.string,
        imgSourceWidth: _react2['default'].PropTypes.number,
        imgSourceHeight: _react2['default'].PropTypes.number

    },
    getInitialState: function getInitialState() {
        return { isActive: this.props.index == 0 };
    },
    onTabClick: function onTabClick() {
        this.props.onTabClick(this.props.index);
    },
    render: function render() {
        var classNames = {};

        classNames = _hfReactHelper2['default'].extend({
            'show-for-large-up': false,
            'is-active': this.props.isActive
        }, this.props.tabClassNames || {});

        if (this.props.clickableItemData.tabTypes == 'tabs') {
            classNames = _hfReactHelper2['default'].extend({ 'm-tabs--tab': true, 'large-3': true, 'columns': true }, classNames);
        } else if (this.props.clickableItemData.tabTypes == 'tiles') {
            classNames = _hfReactHelper2['default'].extend({ 'm-tabs_tiles--tiles': true }, classNames);
        }

        var classes = (0, _classnames2['default'])(classNames);
        if (this.props.clickableItemData.tabTypes == 'tabs') {
            return _react2['default'].createElement(
                'div',
                { className: classes, onClick: this.onTabClick },
                ' ',
                this.props.clickableItemData.title,
                ' '
            );
        } else if (this.props.clickableItemData.tabTypes == 'tiles') {

            var clickableImage = _react2['default'].createElement(_clickableImage2['default'], { imgSourceActiveWidth: this.props.clickableItemData.imgSourceActiveWidth, imgSourceActiveHeight: this.props.clickableItemData.imgSourceActiveHeight, imgSourceInactiveWidth: this.props.clickableItemData.imgSourceInactiveWidth, imgSourceInactiveHeight: this.props.clickableItemData.imgSourceInactiveHeight, imgSourceActive: this.props.clickableItemData.imgSourceActive, imgSourceInactive: this.props.clickableItemData.imgSourceInactive, isActive: this.props.isActive, imgText: this.props.clickableItemData.imgText });
            return _react2['default'].createElement(
                'div',
                { className: classes, onClick: this.onTabClick },
                ' ',
                clickableImage,
                ' '
            );
        }
    }
});

module.exports = Tab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/tabbed-area/tab.jsx
 ** module id = 1137
 ** module chunks = 0
 **/